import artifact from '$houdini/artifacts/DeleteVehicleAttachments'
import { MutationStore } from '../runtime/stores/mutation'

export class DeleteVehicleAttachmentsStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
